import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn, createRenameTransformer } from '../common/utils';
import { buildRecordId } from '../recordIds';
import { DBRoomSchema, RoomSchema } from './schemas';

export const RoomCodecConfig: TransformerConfig<typeof RoomSchema, typeof DBRoomSchema, 'id'> = {
  name: 'Room',
  clientSchema: RoomSchema,
  dbSchema: DBRoomSchema,
  transformers: [createRenameTransformer<typeof RoomSchema, typeof DBRoomSchema>('code', 'roomId')],
  derived: { id: room => buildRecordId('room', room) },
};

export const encodeRoomToDb = createEncodeToDbFn(RoomCodecConfig);
export const decodeRoomFromDb = createDecodeFromDbFn(RoomCodecConfig);
